export default "__VITE_ASSET__BfqcJ9za__"